module.exports = __webpack_public_path__ + "img/tasks.8169fbd9.jpg";